import React from "react";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CCard,
  CCardBody,
  CRow,
  CCol,
  CBadge,
} from "@coreui/react";
import Audit from "../../models/audit";
import { formatDateTime } from "../../utils/dates";

interface AuditChangesModalProps {
  show: boolean;
  onClose: () => void;
  audit: Audit | undefined;
}

const AuditChangesModal: React.FC<AuditChangesModalProps> = ({
  show,
  onClose,
  audit,
}) => {
  if (!audit) {
    return null;
  }

  const getOperationColor = (initiator: string) => {
    if (initiator.includes("create")) return "success";
    if (initiator.includes("update")) return "warning";
    if (initiator.includes("delete")) return "danger";
    return "info";
  };

  // Helper function to display values properly
  const displayValue = (value: any) => {
    if (value === null || value === undefined) {
      return <em className="text-muted">Vacío</em>;
    }

    if (typeof value === "boolean") {
      return value ? "Sí" : "No";
    }

    if (typeof value === "object") {
      return <pre>{JSON.stringify(value, null, 2)}</pre>;
    }

    return String(value);
  };

  return (
    <CModal show={show} onClose={onClose} size="lg">
      <CModalHeader closeButton>
        <CModalTitle>Detalles de Cambios</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CCard>
          <CCardBody>
            <CRow className="mb-3">
              <CCol md="4">
                <strong>Fecha:</strong>
              </CCol>
              <CCol md="8">{formatDateTime(new Date(audit.date))}</CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol md="4">
                <strong>Entidad:</strong>
              </CCol>
              <CCol md="8">{audit.entityName}</CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol md="4">
                <strong>Usuario:</strong>
              </CCol>
              <CCol md="8">{audit.userEmail || "Sistema"}</CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol md="4">
                <strong>Operación:</strong>
              </CCol>
              <CCol md="8">
                <CBadge color={getOperationColor(audit.operation)}>
                  {audit.operation}
                </CBadge>
              </CCol>
            </CRow>

            <hr />

            <h5>Cambios:</h5>
            {audit.changes && Object.keys(audit.changes).length > 0 ? (
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Campo</th>
                      <th>Valor Anterior</th>
                      <th>Nuevo Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(audit.changes).map(([field, change]) => (
                      <tr key={field}>
                        <td>{change.field}</td>
                        <td>{displayValue(change.old)}</td>
                        <td>{displayValue(change.new)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-muted">No hay cambios para mostrar</p>
            )}
          </CCardBody>
        </CCard>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose}>
          Cerrar
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default AuditChangesModal;
